import styled from "styled-components";

export const ModalContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgb(34, 64, 109, 0.6);
`;

export const MyModal = styled.div`
  background: #ffffff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  max-width: 540px;
  border-radius: 16px;
`;

export const Heading = styled.h4`
  font-family: "SangBleu Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  color: #05162a;
  margin-bottom: 16px;
`;

export const Subtitle = styled.p`
  ont-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: #8a919c;
  margin-bottom: 24px;
`;

export const Iconend = styled.div`
  display: flex;
  justify-content: flex-end;
`;

// styles for ActionModal
export const Modal = styled(MyModal)`
  width: 300px;
`;

export const HeadingCenter = styled(Heading)`
  text-align: center;
  // width: 200px;
  padding: 0px 30px;
  margin-bottom: 20px;
`;

export const TransparentBtn = styled.button`
  font-family: "Poppins";
  font-size: 16px;
  line-height: 24px;
  color: #4d9fc4;
  outline: none;
  border: none;
  background: transparent;
  cursor: pointer;
  font-weight: 500;
  margin: 0 auto;
`;

export const AlignCenter = styled.div`
  text-align: center;
`;

export const AlignCenterWithMargin = styled(AlignCenter)`
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const ModalIcon = styled.img`
  &:hover {
    cursor: pointer;
  }
`;

export const GradingModalImage = styled(ModalIcon)`
  marginbottom: 1em;
`;
